import React from "react";
import { Box, Container, Typography, Link, IconButton } from "@mui/material";
import { Facebook, Twitter, Instagram, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: (theme) =>
          theme.palette.mode === "light"
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" color="text.secondary">
            © {new Date().getFullYear()} Blog. All rights reserved.
          </Typography>

          <Box sx={{ mt: { xs: 2, md: 0 } }}>
            <IconButton aria-label="Facebook" href="#" sx={{ mr: 1 }}>
              <Facebook />
            </IconButton>
            <IconButton aria-label="Twitter" href="#" sx={{ mr: 1 }}>
              <Twitter />
            </IconButton>
            <IconButton aria-label="Instagram" href="#" sx={{ mr: 1 }}>
              <Instagram />
            </IconButton>
            <IconButton aria-label="LinkedIn" href="#">
              <LinkedIn />
            </IconButton>
          </Box>

          <Box sx={{ mt: { xs: 2, md: 0 } }}>
            <Link href="#" color="text.secondary" sx={{ mr: 2 }}>
              Privacy Policy
            </Link>
            <Link href="#" color="text.secondary" sx={{ mr: 2 }}>
              Terms of Service
            </Link>
            <Link href="#" color="text.secondary">
              Contact
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
